<label
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[class.disabled]="disabled"
	[formGroup]="form"
	[matTooltipDisabled]="!error"
>
	<p class="is-absolute-centered">
		@if (label === ".") {
			<span> {{ label }} </span>
		} @else {
			<span> {{ label }} </span>
			<span>
				@if (label !== ".") {
					@if (suffixTemplate) {
						<ng-template [ngTemplateOutlet]="suffixTemplate" [ngTemplateOutletContext]="{ $implicit: suffix }" />
					} @else {
						{{ suffix }}
					}
				}
			</span>
		}
	</p>
	<input
		#input
		formControlName="value"
		type="number2"
		[max]="max"
		[min]="min"
		(blur)="blurOnInput($event)"
		(focus)="toggleList()"
		(input)="onChange($any($event).target.value)"
		(keydown.Tab)="tabOnInput($any($event), $any($event).target.value)"
	/>
</label>

@if (showList && !disabled && items.length > 0) {
	<ul tabindex="-1">
		@for (item of items; track item; let i = $index) {
			<li
				#listItem
				(blur)="blur(i)"
				(focus)="setItemIndex(i)"
				(focusClick)="selectItem(item)"
				(keyup)="handleKeyUp($event, item)"
			>
				@if (itemTemplate) {
					<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
				} @else {
					{{ item }}
				}
			</li>
		}
	</ul>
}
